import { CostEnum } from "../../../Enum/cost-enum";

export class KmsDto {
    routeType: string;
   kms:number
   vehicleType:string
   type:string
   vendorId?:number
   extraHrs?:number




    constructor(
        routeType: string,
        kms: number,
        vehicleType:string,
        type:string,
        vendorId?:number,
        extraHrs?:number
    ) {
        this.routeType = routeType;
        this.kms = kms;
        this.vehicleType = vehicleType;
        this.type = type;
        this.vendorId = vendorId;
        this.extraHrs = extraHrs;

    }
}

export class RouteCostIdreq{
    routeCostId:number;
    plant?:number
    constructor(
    routeCostId:number,
    plant?:number
    ){
        this.routeCostId=routeCostId
        this.plant=plant
    }
}